import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EvidencePage, OpenDocumentResponse } from '../models/evidence.model';

@Injectable({ providedIn: 'root' })
export class EvidenceApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.CRD_API}v3/public/evidence`;

  /**
   * The token travels in the Authorization header, never in the URL, so no
   * access log, error log or error tracker on the API side sees it.
   */
  private headers(token: string): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
  }

  getPage(token: string): Observable<EvidencePage> {
    return this.http.get<EvidencePage>(this.baseUrl, {
      headers: this.headers(token)
    });
  }

  /** Observed as a full response because 200 and 202 carry different bodies. */
  open(
    token: string,
    itemId: string
  ): Observable<HttpResponse<OpenDocumentResponse>> {
    return this.http.get<OpenDocumentResponse>(
      `${this.baseUrl}/items/${itemId}/open`,
      { headers: this.headers(token), observe: 'response' }
    );
  }
}
